import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCup"><Path d="M3.75 3.75H16.25V17.25C16.25 18.9069 14.9069 20.25 13.25 20.25H6.75C5.09315 20.25 3.75 18.9069 3.75 17.25V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M16.25 6.75H17.5C19.0188 6.75 20.25 7.98122 20.25 9.5C20.25 11.0188 19.0188 12.25 17.5 12.25H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconCup;
